import { getCountries, getProductListingAttributes } from '@app/ducks';
import { applyCountryNameToAttribute, getCustomAttributesWithValue } from '@app/logic/products';
import { isEmpty } from '@app/utils/isEmpty';
import { Product } from '@typings';
import React from 'react';
import { useSelector } from 'react-redux';

const MEDIUM_CARD_NUMBER_OF_ATTRIBUTES = 3;

interface Props {
  variant: Product.Standard;
  twoColumns?: boolean;
}

export const CmsProductCardAttributes = ({ variant }: Props) => {
  const countries = useSelector(getCountries);
  const listingAttributes = useSelector(getProductListingAttributes);

  const attributes = React.useMemo(() => {
    const filteredAttributes = applyCountryNameToAttribute(getCustomAttributesWithValue(listingAttributes, variant), countries).filter(
      ({ value }) => !isEmpty(value),
    );

    return filteredAttributes.slice(0, MEDIUM_CARD_NUMBER_OF_ATTRIBUTES);
  }, []);

  return (
    <dl className="columns-3xs gap-10">
      {attributes.map(({ name, value, key }) => (
        <div key={key} className="line-clamp-1 flex max-w-80 break-inside-avoid-column gap-1">
          <dt className="whitespace-nowrap text-neutral-40 body-5">{name}: </dt>
          <dd className="truncate body-4">{value}</dd>
        </div>
      ))}
    </dl>
  );
};
